'use strict';


app.factory('Payment', ['$rootScope', '$http', 'Router', 'Drink', 'Cart', 'User', 'env_config',
    function ($rootScope, $http, Router, Drink, Cart, User, env_config) {
        var service = {};


        /**
         * make payment
         *
         * @param String  payment_type  waave_credit | paypal | credit_card
         * @param String  pay_for       drink | money
         */
        service.make = function(payment_type, pay_for, callback) {

            var post_data     = {};
            var selected_user = '';
            var api_url = env_config.api_url;

            switch (pay_for) {
                case 'drink' :
                    selected_user = $rootScope.globals.selectedUser;
                    api_url += 'gift/' + selected_user.id;

                    post_data = this.prepareDrinkOrderObject(payment_type);
                    break;

                case 'money' :
                    selected_user = $rootScope.globals.selectedUser;
                    api_url += 'gift/' + selected_user.id;

                    post_data = this.prepareMoneyOrderObject(payment_type);
                    break;

                case 'ticket':
                    api_url += 'api/tickets/' + $rootScope.globals.ticketedEvent.event.slug + '/purchase';

                    post_data = this.prepareTicketOrderObject(payment_type);
                    break;

                default      :
                    console.error('Wrong pay_for parameter was passed!');
                    break;
            }


            // make the call to api
            $http.post(api_url, post_data)
                .success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        };


        /**
         * prepare drink object to be used in create order request
         *
         * @param  String payment_type  waave_credit | paypal | credit_card
         * @return Object data
         */
        service.prepareDrinkOrderObject = function(payment_type){

            var selected_venue = $rootScope.globals.selectedVenue;
            var selected_drink = $rootScope.globals.selectedDrink;
            var drink_quantity = 1;
            var selected_drink_options = Drink.getSelectedDrinkOptions();

            // if double drink option is selected than double the quantity
            // this is because api likes it this way
            if( Drink.isDoubleDrinkOptionSelected() ) drink_quantity = 2;

            // main object
            var data = {
                drinkId               : [ selected_drink.id ],
                drinkQty              : [ drink_quantity ],
                drinkOptions          : [ JSON.stringify(selected_drink_options) ],
                drinkPrice            : [ Drink.getPrice(selected_drink) ],               // we are sending normal price, not double (if that option is selected)
                venue_id              : selected_venue.id,
                personal_message      : $rootScope.globals.cartData.personal_message,
                type                  : 1,                                                // 1 - send drink, 2 - send money
                amount                : Cart.getTotal(),
                'serviceType[id]'     : 1,                                                // 1 - pickup at the bar, this is the only service web-app supports
                'serviceType[option]' : 'pickup'
            };

            switch( payment_type ){
                case 'waave_credit': break;

                case 'paypal':
                    data.payment_type = 'paypal';
                    data.payment_method_nonce = $rootScope.braintree.paypal_object.nonce;
                    break;

                case 'credit_card':
                    data.payment_type = 'creditcard';
                    data.payment_method_nonce = $rootScope.braintree.credit_card_object.nonce;
                    break;

                default:
                    console.error('Wrong payment_type was passed!');
                    break;
            }

            return data;
        }


        /**
         * prepare money object to be used in create order request
         *
         * @param  String payment_type  waave_credit | paypal | credit_card
         * @return Object data
         */
        service.prepareMoneyOrderObject = function(payment_type){

            // if double drink option is selected than double the quantity
            // this is because api likes it this way
            if( Drink.isDoubleDrinkOptionSelected() ) drink_quantity = 2;

            // main object
            var data = {
                personal_message      : $rootScope.globals.cartData.personal_message,
                type                  : 2,                                                // 1 - send drink, 2 - send money
                amount                : $rootScope.globals.selectedMoney.amount,
            };

            switch( payment_type ){
                case 'waave_credit': break;
                
                case 'paypal':
                    data.payment_type = 'paypal';
                    data.payment_method_nonce = $rootScope.braintree.paypal_object.nonce;
                    break;

                case 'credit_card':
                    data.payment_type = 'creditcard';
                    data.payment_method_nonce = $rootScope.braintree.credit_card_object.nonce;
                    break;

                default:
                    console.error('Wrong payment_type was passed!');
                    break;
            }

            return data;
        }


        /**
         * prepare ticket object to be used in buy tickets request
         *
         * @param  String payment_type  waave_credit | paypal | credit_card
         * @return Object data
         */
        service.prepareTicketOrderObject = function(payment_type){
            var drinkIds = [];
            var drinkQtys = [];

            // prepare tickets
            angular.forEach($rootScope.globals.ticketedEvent.tickets, function(ticket) {
                if(ticket.count>0){
                    drinkIds.push(ticket.id);
                    drinkQtys.push(ticket.count);
                }
            });

            // main object
            var data = {
                drinkId : drinkIds,
                drinkQty: drinkQtys
            };

            switch( payment_type ){
                case 'waave_credit':
                    data.payment_type = 'waave-credit';
                    break;
                
                case 'paypal':
                    data.payment_type = 'paypal';
                    data.payment_method_nonce = $rootScope.braintree.paypal_object.nonce;
                    break;

                case 'credit_card':
                    data.payment_type = 'creditcard';
                    data.payment_method_nonce = $rootScope.braintree.credit_card_object.nonce;
                    break;

                default:
                    console.error('Wrong payment_type was passed!');
                    break;
            }

            return data;
        }


        return service;
    }]);